import { render, staticRenderFns } from "./FoliosListCreate.vue?vue&type=template&id=211128c6&"
import script from "./FoliosListCreate.vue?vue&type=script&lang=js&"
export * from "./FoliosListCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports